<style lang="less" scoped>
  @import "../../vars.less";
  .button-container {
    padding: @space-normal @space-normal;
    background-color: #fff;
    & > *:not(:first-child) {
      margin-top: @space-normal;
    }
  }
</style>

<template>
  <div class="order">
    <van-form input-align="right" label-width="40%">
      <van-field
        :label="$t('销售订单号')"
        :placeholder="$t('请输入销售订单号')"
        v-model="conditions.OrderNumber"
        clearable />
      <van-field
        :label="$t('客户号')"
        :placeholder="$t('请输入客户号')"
        v-model="conditions.CustomerNumber"
        clearable />
      <van-field
        :label="$t('客户采购订单号')"
        :placeholder="$t('请输入客户采购订单号')"
        v-model="conditions.CustomerOrderNumber"
        clearable />
      <tag-radios
        label-width="24%"
        :label="$t('订单状态')"
        input-align="right"
        :options="[
          { value: 2, text: $t('未完成') },
          { value: 1, text: $t('已完成') },
          { value: 0, text: $t('全部') },
        ]"
        v-model="conditions.OrderStatus" />
      <tag-radios
        label-width="26%"
        :label="$t('最近')"
        input-align="right"
        @change="handleRecentChange"
        :options="[
          { value: 7, text: $t('1周') },
          { value: 14, text: $t('2周') },
          { value: 30, text: $t('1个月') },
          { value: 90, text: $t('3个月') },
          { value: 180, text: $t('6个月') },
          { value: 0, text: $t('全部') },
        ]"
        v-model="conditions.recent" />
      <range-picker type="date"
        v-model="conditions.range"
        @change="handleRangeChange"
        :label="$t('订单起始时间')" />
      <van-field
        :label="$t('商务')"
        :placeholder="$t('请输入商务姓名')"
        v-model="conditions.EmployeeName"
        clearable />
      <van-field
        :label="$t('销售订单物料号/标准订货号')"
        :placeholder="$t('请输入销售订单物料号/标准订货号')"
        v-model="conditions.Mlfb"
        clearable />
      <van-field
        :label="$t('特价单号')"
        :placeholder="$t('请输入特价单号')"
        v-model="conditions.SPRNumber" />
      <van-field name="radio" :label="$t('信用锁定')">
        <template #input>
          <van-radio-group v-model="conditions.CreditBlock" direction="horizontal">
            <van-radio :name="-1">{{$t('全部')}}</van-radio>
            <van-radio :name="1">{{$t('是')}}</van-radio>
            <van-radio :name="0">{{$t('否')}}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
    </van-form>
    <div class="button-container">
      <van-button type="info" size="small" v-if="$auth('Order_Query')"
        round block
        @click="() => query()" >{{$t('查询')}}</van-button>
      <van-button v-if="$auth('Order_MatchQuery')"
        :disabled="!canQueryPrecisely"
        type="info" size="small" round block
        @click="() => query(true)">
        {{$t('精确查询')}}
      </van-button>
    </div>
  </div>
</template>

<script>
import {
  Field, Button, Form,
  Radio, RadioGroup
} from 'vant'
import TagRadios from '../../components/TagRadios'
import RangePicker from '../../components/RangePicker'

export default {
  name: 'order',
  components: {
    TagRadios,
    RangePicker,
    'van-field': Field,
    'van-button': Button,
    'van-form': Form,
    'van-radio': Radio,
    'van-radio-group': RadioGroup
  },
  data () {
    return {
      conditions: {
        OrderNumber: '',
        OrderStatus: 0,
        recent: 0,
        range: {
          from: '',
          to: ''
        },
        EmployeeName: '',
        CustomerNumber: '',
        CustomerOrderNumber: '',
        Mlfb: '',
        SPRNumber: '',
        CreditBlock: -1
      },
      showStartPicker: false,
      showEndPicker: false
    }
  },
  computed: {
    canQueryPrecisely () {
      return this.conditions.OrderNumber.trim() &&
        this.conditions.CustomerNumber.trim() &&
        this.conditions.CustomerOrderNumber.trim()
    }
  },
  methods: {
    onStatusConfirm () {
      this.showStatusPicker = false
    },
    onLastConfirm () {
      this.showLastPicker = false
    },
    query (precise) {
      this.$router.push({
        name: 'order-list',
        query: {
          conditions: JSON.stringify({
            ...this.conditions,
            range: {
              from: this.conditions.range.from
                ? this.conditions.range.from.getTime()
                : '',
              to: this.conditions.range.to
                ? this.conditions.range.to.getTime()
                : ''
            }
          }),
          precise
        },
        params: {
          stackType: 'push'
        }
      })
    },
    onStartConfirm () {},
    onEndConfirm () {},
    handleRecentChange (v) {
      if (v) {
        const to = new Date()
        const from = new Date(to.getTime() - v * 24 * 60 * 60 * 1000)
        this.conditions.range = { from, to }
      } else {
        this.conditions.range = { from: '', to: '' }
      }
    },
    handleRangeChange () {
      this.conditions.recent = 0
    }
  }
}
</script>
